// The Partner Code field (ACCOUNT_TIER_RULES.md, Beta Tester standards, 2026-10-30). Used
// for beta access today and other purposes later, so the word "Beta" never appears.

export const STRINGS = {
  en: {
    label: "Partner Code (optional)",
    hint: "If you were given a Partner Code, enter it here.",
    placeholder: "XXXXXXXXXXXX",
    settingsTitle: "Partner Code",
    settingsHint: "Enter a Valid Partner Code you received",
    apply: "Apply code",
    applying: "Applying…",
    applied: (date) => `Partner Code applied. Your access runs until ${date}.`,
  },
  "pt-BR": {
    label: "Código de Parceiro (opcional)",
    hint: "Se você recebeu um Código de Parceiro, digite-o aqui.",
    placeholder: "XXXXXXXXXXXX",
    settingsTitle: "Código de Parceiro",
    settingsHint: "Digite um Código de Parceiro válido que você recebeu",
    apply: "Aplicar código",
    applying: "Aplicando…",
    applied: (date) => `Código de Parceiro aplicado. Seu acesso vai até ${date}.`,
  },
  "es-419": {
    label: "Código de Socio (opcional)",
    hint: "Si recibió un Código de Socio, ingréselo aquí.",
    placeholder: "XXXXXXXXXXXX",
    settingsTitle: "Código de Socio",
    settingsHint: "Ingrese un Código de Socio válido que haya recibido",
    apply: "Aplicar código",
    applying: "Aplicando…",
    applied: (date) => `Código de Socio aplicado. Su acceso dura hasta el ${date}.`,
  },
  "fr-CA": {
    label: "Code partenaire (facultatif)",
    hint: "Si vous avez reçu un Code partenaire, entrez-le ici.",
    placeholder: "XXXXXXXXXXXX",
    settingsTitle: "Code partenaire",
    settingsHint: "Entrez un Code partenaire valide que vous avez reçu",
    apply: "Appliquer le code",
    applying: "Application…",
    applied: (date) => `Code partenaire appliqué. Votre accès est valide jusqu’au ${date}.`,
  },
};

export function partnerCodeStrings(lang) {
  const key = String(lang || "en");
  return STRINGS[key] || STRINGS[Object.keys(STRINGS).find((k) => key.toLowerCase().startsWith(k.slice(0, 2).toLowerCase()))] || STRINGS.en;
}

// The code as the backend stores it: upper case, no spaces or dashes.
export function normalizePartnerCode(value) {
  return String(value || "").toUpperCase().replace(/[\s-]/g, "");
}
